<template>
  <div id="form-upload">
    <v-container>
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >
          Adicionar ou editar anexos
        </v-toolbar>
        <v-card
          elevation="2"
          class="pa-3"
        >
          <div class="ma-5">
            <v-form>
              <input
                id="user-id"
                type="hidden"
                v-model="doc.usuario"
              />
              <input
                id="doc-id"
                type="hidden"
                v-model="doc.id"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="code"
                    label="Código"
                    dense
                    outlined
                  >
                    <v-btn
                      class="btn-outer-right-1 pa-0"
                      slot="append-outer"
                      color="success"
                      tile
                      @click.prevent="loadDialog"
                    >
                      <v-icon
                        class="mx-0"
                        color="white"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="code"
                >
                  <v-checkbox
                    v-model="doc.inativar"
                    label="Inativar arquivo?"
                    color="success"
                    class="mt-0 mb-2"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  lg="5"
                >
                  <v-text-field
                    v-model="doc.nome"
                    label="Nome do documento"
                    dense
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  colls="12"
                  lg="3"
                  md="6"
                >
                  <v-autocomplete
                    label="Categoria do documento:"
                    v-model="doc.uid_tipodoc"
                    :items="tipoAnexo"
                    clearable
                    dense
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  colls="12"
                  lg="2"
                  md="6"
                >
                  <v-autocomplete
                    label="Tipo de documento:"
                    v-model="doc.logodoc"
                    :items="tipoDoc"
                    clearable
                    dense
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  lg="2"
                  md="6"
                >
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dtpub"
                        v-model="data_publicacao"
                        label="Data de publicação.:"
                        dense
                        outlined
                        @blur="mudaDataMidia"
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date"
                      @input="dateF"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <input
                  accept="application/vnd.ms-word, application/vnd.ms-excel, text/html, application/pdf"
                  prepend-icon="mdi-paperclip"
                  label="Documento"
                  v-if="uploadReady"
                  type="file"
                  ref="file"
                  @change="selectFile()"
                >
              </v-row>
            </v-form>
          </div>
          <v-card-actions class="justify-end">
            <v-btn
              color="success"
              class="mr-4 text-none"
              v-if="!doc.id"
              type="submit"
              @click.prevent="anexoUpload()"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="success"
              class="mr-4 text-none"
              v-if="doc.id"
              type="submit"
              @click.prevent="anexoEdit()"
            >
              <v-icon left>
                mdi-file-edit-outline
              </v-icon>
              Atualizar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4 text-none"
              v-if="!code"
              @click="clearUpload"
            >
              <v-icon left>
                mdi-file-remove-outline
              </v-icon>
              Remover anexo
            </v-btn>
            <v-btn
              color="alert"
              class="mr-4 text-none"
              @click="reset"
            >
              <v-icon left>
                mdi-reload
              </v-icon>
              Reset
            </v-btn>
            <v-btn
              color="error"
              class="mr-4 text-none"
              v-if="code"
              @click="delDoc"
            >
              <v-icon left>
                mdi-delete-alert-outline
              </v-icon>
              Deletar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-container>
    <!-- Dialog de pesquisa por anexos -->
    <v-container>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar anexos
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="docs"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadDoc(item)"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'FormUpload',
  computed: mapState(['user']),
  data: () => ({
    dialog: false,
    search: '',
    code: '',
    dtpub: '##/##/####',
    uploadReady: true,
    file: '',
    tabela: 'anexos',
    date: new Date().toISOString().substr(0, 10),
    data_publicacao: '',
    menu: false,
    doc: {},
    docs: [],
    tipoAnexo: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Url', value: 'url' },
      {
        text: 'Situação',
        value: 'situacao',
        sortable: false
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    tipoDoc: [
      { value: 'file-word-box', text: 'Word' },
      { value: 'file-excel-box', text: 'Excel' },
      { value: 'file-pdf-box', text: 'Pdf' },
      { value: 'code-block-tags', text: 'Html' }
    ]
  }),
  methods: {
    dateF () {
      this.data_publicacao = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaDataMidia () {
      const [dia, mes, ano] = this.data_publicacao.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    updateDoc () {
      const method = this.doc.id ? 'put' : 'post'
      const id = this.doc.id ? `/${this.doc.id}` : ''
      axios[method](`${baseApiUrl}/anexos-de-projetos${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.clearAnexo()
          this.loadAnexos()
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async anexoUpload () {
      const formData = new FormData()
      const method = this.doc.id ? 'put' : 'post'
      const id = this.doc.id ? `/${this.doc.id}` : ''
      const url = `${baseApiUrl}/upload-anexos-diversos${id}`
      formData.append('nome', this.doc.nome)
      formData.append('uid_tipodoc', this.doc.uid_tipodoc)
      formData.append('logodoc', this.doc.logodoc)
      formData.append('tabela', this.tabela)
      formData.append('data_publicacao', this.date)
      formData.append('usuario', this.doc.usuario)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    clearUpCampos () {
      this.doc = {}
      this.file = ''
    },
    resetUpload () {
      this.doc = {}
      this.file = ''
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    reset () {
      this.code = ''
      this.doc = {}
      this.docs = []
      this.loadDatas()
    },
    anexoEdit () {
      this.doc.data_publicacao = this.date
      const id = this.doc.id
      axios.put(`${baseApiUrl}/uploads-diversos/${id}`, this.doc)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          if (id) {
            this.loadUpdate()
          }
        })
        .catch(showError)
    },
    delDoc () {
      alert('Deseja realmente excluir este anexo permanentemente?')
    },
    loadDoc (item) {
      const id = item.id
      const url = `${baseApiUrl}/uploads-diversos/${id}`
      axios.get(url).then(res => {
        this.doc = res.data
        this.code = this.doc.id
        if (this.doc.data_publicacao === null) {
          this.doc.data_publicacao = null
        } else {
          this.data_publicacao = moment(this.doc.data_publicacao).format('DD/MM/YYYY')
          this.date = moment(this.doc.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.docs = []
      this.dialog = false
    },
    loadUpdate () {
      const id = this.doc.id
      const url = `${baseApiUrl}/uploads-diversos/${id}`
      axios.get(url).then(res => {
        this.doc = res.data
        this.code = this.doc.id
        if (this.doc.data_publicacao === null) {
          this.doc.data_publicacao = null
        } else {
          this.data_publicacao = moment(this.doc.data_publicacao).format('DD/MM/YYYY')
          this.date = moment(this.doc.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.docs = []
      this.dialog = false
    },
    loadAnexos () {
      const url = `${baseApiUrl}/uploads-diversos`
      axios.get(url).then(res => {
        this.docs = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadDialog () {
      this.dialog = true
      this.loadAnexos()
    },
    loadTipoAnexo () {
      const url = `${baseApiUrl}/categoria-de-documentos`
      axios.get(url).then(res => {
        this.tipoAnexo = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.cat_doc}`
          }
        })
      })
    },
    loadDatas () {
      const dataAgora = new Date().toISOString().substr(0, 10)
      this.data_publicacao = moment(dataAgora).format('DD/MM/YYYY')
      this.date = dataAgora
      this.doc.usuario = this.user.id
    }
  },
  created () {
    this.loadDatas()
    this.loadTipoAnexo()
  }
}
</script>
<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.btn-outer-right-1 {
  margin-top: -8px !important;
  margin-left: -12px !important;
  border-top: solid 1px #878f97 !important;
  border-right: solid 1px #878f97 !important;
  border-bottom: solid 1px #878f97 !important;
}
.v-size--default {
  height: 39px !important;
  min-width: 38px !important;
}
</style>
